import { useLocation, useNavigate } from "react-router";
import { useBackState } from "@/book/components/back";
import { useDailyPick, useDrawDaily } from "@/shared/api/book";

/** A mai gyakorlat megnyitása (rendszerterv 8.): ha még nem kért mára, a hívás húz egyet és
 *  megnyitja; ha már van, egyből rá visz. A kezdőlap csempéje és a „Több" (mobilon panel,
 *  asztalon lenyíló menü) ugyanezt használja — a lekérdezés közös, egyszer fut. */
export function useOpenDaily() {
  const { data, isPending } = useDailyPick();
  const draw = useDrawDaily();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const back = useBackState();
  const exercise = data?.exercise ?? null;
  const busy = draw.isPending;

  /** A gyakorlat fejléce oda kínál visszautat, ahonnan a menüpontot megnyomták. Ha már
   *  rajta állunk, nem lépünk — különben a „vissza" ugyanide hozna. */
  const go = (id: number) => {
    const to = `/app/book/gyakorlatok/${id}`;
    // a `from` a használati statisztikának mondja meg, honnan nyílt a gyakorlat (9.1)
    if (pathname !== to) navigate(to, { state: { ...back, from: "daily" } });
  };

  const open = () => {
    if (exercise) {
      go(exercise.id);
      return;
    }
    draw.mutate(undefined, {
      onSuccess: (pick) => {
        if (pick.exercise) go(pick.exercise.id);
      },
    });
  };

  const label = busy
    ? "Választok…"
    : exercise
      ? exercise.title
      : data?.exhausted
        ? "Most nincs több"
        : "Kérek egyet mára";

  return { open, label, exercise, disabled: isPending || busy || Boolean(data?.exhausted) };
}
